// extracted by mini-css-extract-plugin
export default {"container":"CartBadge_container__9UlUP","total":"CartBadge_total__E7mr0"};